import { z } from 'zod';
import { OfferSchema } from '~entities/offer/model/offer.contracts';

export const OccupancySchema = z.object({
  adults: z.number(),
  children: z.array(z.number()),
});

export const BookingRoomSchema = z.object({
  id: z.string().uuid(),
  offeringId: z.number().int().optional(),
  cartItemId: z.string().optional(),
  offer: OfferSchema,
  occupancy: OccupancySchema,
});
